import { Button, Paper, Typography } from '@mui/material'
import { useState } from 'react'
import { EmailChipField } from './EmailChipField'
import { styles } from './InviteeList.styles'

interface Props {
  isSending: boolean
  onSend: (emails: string[]) => Promise<boolean>
}

export const InviteForm = ({ isSending, onSend }: Props): JSX.Element => {
  const [emails, setEmails] = useState<string[]>([])
  const [hasInvalid, setHasInvalid] = useState<boolean>(false)

  const send = async (): Promise<void> => {
    if (await onSend(emails)) setEmails([])
  }

  return (
    <Paper variant='outlined' sx={styles.panel}>
      <Typography variant='h4' mb='4px'>Invite Users</Typography>
      <Typography variant='body2' color='text.secondary' mb='12px'>Type or paste email addresses. Separate multiple with a comma.</Typography>
      <EmailChipField emails={emails} onChange={setEmails} onInvalidChange={setHasInvalid} />
      <Button
        variant='contained' onClick={() => { void send() }} data-testid='p2pSendInvitations'
        disabled={isSending || emails.length === 0 || hasInvalid} sx={styles.sendButton}
      >
        Send Invite
      </Button>
    </Paper>
  )
}
